import {useAppSelector} from '../hooks';

const useSessionSettings = () => {
  const sessions = useAppSelector(state => state.settings.sessions);
  return sessions || {};
};

export default useSessionSettings;
